/**
 * A cégválasztó cégsora (#73) — `GET /companies/selectable`.
 *
 * A szerver ezt a végpontot a felhasználó TELJES hatókörével szolgálja ki,
 * a választástól függetlenül (`@IgnoreCompanySelection()`): a választás után
 * is az összes választható cég jön, nem csak a kiválasztott.
 */

import { useEffect, useState } from 'react';
import { api } from '@/lib/api-client';
import type { PickerCompany } from './rankCompanies';

export type SelectableCompanies =
  | { status: 'loading' }
  | { status: 'ready'; companies: PickerCompany[] }
  | { status: 'failed' };

export function useSelectableCompanies(enabled: boolean): SelectableCompanies {
  const [state, setState] = useState<SelectableCompanies>({ status: 'loading' });

  useEffect(() => {
    if (!enabled) {
      return;
    }
    let live = true;
    api<PickerCompany[]>('/companies/selectable')
      .then((companies) => {
        if (live) setState({ status: 'ready', companies });
      })
      .catch(() => {
        if (live) setState({ status: 'failed' });
      });
    return () => {
      live = false;
    };
  }, [enabled]);

  return state;
}
